var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-chip',{staticClass:"text--bold status-chip",style:(_vm.chipStyle),attrs:{"color":_vm.chipColor,"label":"","small":""}},[_c('v-icon',{attrs:{"left":"","small":""}},[_vm._v(_vm._s(_vm.chipIcon))]),_vm._v(" "+_vm._s(_vm.label)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }